
import Vue from 'vue'
import TopBar from '@/components/TopBar.vue'
import BottomBar from '@/components/BottomBar.vue'
import Pin from '@/components/Pin.vue'
import Controls from '@/components/Controls.vue'
import CategoryMenu from '@/components/CategoryMenu.vue'
import Background from '@/components/Background.vue'
import UploadModal from '@/components/UploadModal.vue'
import { mapper } from '@/stores/store'

export default Vue.extend({
  name: 'Home',
  components: {
    TopBar,
    BottomBar,
    Pin,
    Controls,
    CategoryMenu,
    Background,
    UploadModal
  },
  computed: {
    ...mapper(['uploading', 'categoryMenuOpen', 'activeCategory', 'uploadTooltip']),
  },
  mounted () {
    // Handle upload tooltip
    if (this.uploadTooltip) {
      this.$el.addEventListener('click', this.onClickElement, false)
    }
  },
  destroyed () {
    this.$el.removeEventListener('click', this.onClickElement)
  },
  methods: {
    ...mapper(['finishEditingUpload', 'showUploadTooltip']),
    onClickElement() {
      this.showUploadTooltip(false)
    }
  },
})
